import React from "react";




const cars = [
  {
    id: 1,
    name: "Swift Dzire",
    image: "/images/Fleet/Swift-Dzire.jpeg",
    seats: "4 Seats",
    bags: "2 Bags",
    type: "Sedan",
    fuel: "Petrol+CNG",
  },
  {
    id: 2,
    name: "Kia Carens",
    image: "/images/Fleet/Kia-Carens.jpg",
    seats: "6 Seats",
    bags: "3 Bags",
    type: "MUV",
    fuel: "Petrol",
  },
  {
    id: 3,
    name: "Innova Cab",
    image: "/images/Fleet/Innova-Cab.jpg",
    seats: "7 Seats",
    bags: "4 Bags",
    type: "SUV",
    fuel: "Diesel",
  },
  {
    id: 4,
    name: "Innova Crysta",
    image: "/images/Fleet/Innova-Crysta.jpeg",
    seats: "7 Seats",
    bags: "4 Bags",
    type: "SUV",
    fuel: "Diesel",
  },
  {
    id: 5,
    name: "Maruti Ertiga",
    image: "/images/Fleet/Maruti-Ertiga.jpg",
    seats: "7 Seats",
    bags: "3 Bags",
    type: "MUV",
    fuel: "Petrol / CNG",
  },
  {
    id: 6,
    name: "Toyota Rumion",
    image: "/images/Fleet/Toyota-Rumion.jpg",
    seats: "7 Seats",
    bags: "3 Bags",
    type: "MUV",
    fuel: "Petrol",
  },
  {
    id: 10,
    name: "Winger 9+1 Seater",
    image: "/images/Fleet/wagon-r.jpeg",
    seats: "9+1 Seats",
    bags: "6 Bags",
    type: "Traveller",
    fuel: "Diesel",
  },

  {
    id: 12,
    name: "Innova Hycross",
    image: "/images/Fleet/Innova-hycross.jpeg",
    seats: "7 Seats",
    bags: "4 Bags",
    type: "SUV",
    fuel: "Petrol / Hybrid",
  },
  
  {
    id: 7,
    name: "Tempo Traveller",
    image: "/images/Fleet/Tempo-Traveller.jpg",
    seats: "17 Seats",
    bags: "10 Bags",
    type: "Traveller",
    fuel: "Diesel",
  },

  
    {
    id: 9,
    name: "13 Seater Tempo Traveller",
    image: "/images/Fleet/13.jpeg",
    seats: "13 Seats",
    bags: "20 Bags",
    type: "Mini Bus",
    fuel: "Diesel",
  },
    {
    id: 11,
    name: "Tempo Traveller 20 Seater",
    image: "/images/Fleet/tempo-traveller-20-seater.jpeg",
    seats: "20 Seats",
    bags: "12 Bags",
    type: "Traveller",
    fuel: "Diesel",
  },
  {
    id: 8,
    name: "Urbania Bus",
    image: "/images/Fleet/Urbania-Bus.jpg",
    seats: "17 Seats",
    bags: "12 Bags",
    type: "Luxury Van",
    fuel: "Diesel",
  },
  {
    id: 9,
    name: "Mini Bus",
    image: "/images/Fleet/Mini-Bus.jpg",
    seats: "25 Seats",
    bags: "20 Bags",
    type: "Mini Bus",
    fuel: "Diesel",
  },




 
      {
    id: 9,
    name: "40 Seater Bus",
    image: "/images/Fleet/bus-3.jpeg",
    seats: "40 Seats",
    bags: "20 Bags",
    type: "Mini Bus",
    fuel: "Diesel",
  },
       {
    id: 9,
    name: "49 Seater Bus",
    image: "/images/Fleet/bus.jpeg",
    seats: "49 Seats",
    bags: "20 Bags",
    type: "Mini Bus",
    fuel: "Diesel",
  },

];


const Ourfleets = () => {
  return (


    <>




 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Our Fleets
        </h2>
      </div>
    </section>

 

    <div className="section-full py-3 site-bg-white twm-cars-section-wrap">
      <div className="container">
        <div className="section-content">
          <div className="twm-cars-section m-b30">
            <div className="row">
              {cars.map((car) => (
                <div
                  key={car.id}
                  className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                  data-wow-delay="0.2s"
                >
                  <div className="twm-vehicle-fleet-bx twm-custom-grid-3">
                    <div className="twm-media">
                      <div className="twm-media-pic">
                        <img src={car.image} alt={car.name} />
                      </div>

                
                    </div>

                   

             <div className="twm-vehicle-fleet-content">

    <h3 className="fleet-title text-">
        {car.name}
    </h3>

    <div className="fleet-info">

        <div className="fleet-item">
            <i className="fa-solid fa-chair"></i>
            <span>{car.seats}</span>
        </div>

        <div className="fleet-item">
            <i className="fa-solid fa-suitcase"></i>
            <span>{car.bags}</span>
        </div>

        <div className="fleet-item">
            <i className="fa-solid fa-car-side"></i>
            <span>{car.type}</span>
        </div>

        <div className="fleet-item">
            <i className="fa-solid fa-gas-pump"></i>
            <span>{car.fuel}</span>
        </div>

    </div>

    <a href="/booking" className="fleet-btn ghj">
        Book Now
        <i className="fa-solid fa-arrow-right"></i>
    </a>

</div>
                  </div>
                </div>
              ))}
            </div>

          
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Ourfleets;